import { createContext } from "react";

import type { IRydeProcess, RydeUiUnit } from "@ryde/shared";

export interface IProcessDrawerContext {
  currentProcess?: IRydeProcess;
  entity?: RydeUiUnit;
}

export const ProcessDrawerContext = createContext<IProcessDrawerContext>({
  currentProcess: undefined,
  entity: undefined,
});
